<template>
    <div id="app">
        
        <header id="header">
            <ul class="header-inner m-l-10">

                <li class="logo m-t-10">
                    <a href="/"> Elecciones UNC - Consultas al padrón electoral</a>
                </li>
               
            </ul>
        </header>

        <section id="main">

            <section id="content">
                <div id="main-body" class="container">
                    <router-view></router-view>
                </div>
            </section><!--/.content-->
            
        </section><!--/.main-->

        <footer id="footer">
            <img src="./assets/img/unc-logo-footer.png" alt="">
        </footer>

    </div>

</template>

<script>
    import { HTTPv2} from './share.js';

    export default {
        name: 'app',
        data () {
            return {
            }
        },
        methods: {
        }
    } 

</script>

<style lang="scss">

</style>
